import { StateObject } from '~src/domains/common/types/common';

const marketingCommunicationOptInSelector = (state: StateObject) =>
  state.start.marketingCommunicationOptIn;

const marketingCommunicationOptInDirtySelector = (state: StateObject) =>
  state.start.marketingCommunicationOptInDirty;

const startFormSelector = (state: StateObject) => state.startForm;

export {
  marketingCommunicationOptInSelector,
  startFormSelector,
  marketingCommunicationOptInDirtySelector,
};
